// BMRCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { BMR_EndPoint } from "./ConstantsHealthCalculator";
import BMRTable from "./BMRTable";
const TITLE = "Kalkulator Laju Metabolisme Basal - Kalkulator BMR";
const DESCRIPTION =
  "Kalkulator BMR gratis dan canggih kami didasarkan pada rumus BMR yang terkenal dan membantu menghitung laju metabolisme basal (BMR), jumlah kalori per hari";
const KEYWORDS =
  "hitung laju metabolisme basal, kalkulator BMR, laju metabolisme basal tubuh, cara menghitung laju metabolisme basal, laju metabolisme basal dan kalori, rumus hitung laju metabolisme basal, apa itu laju metabolisme basal?, pentingnya laju metabolisme basal untuk kesehatan, bagaimana laju metabolisme basal mempengaruhi penurunan berat badan?, cara meningkatkan laju metabolisme basal";
const OG_URL = "https://do-calculate.com/calculator/id/bmr/";
const apiEndpoint = `${SERVER_URL}/${BMR_EndPoint}`;
function BMRCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [formula, setFormula] = useState("harrisBenedictRevised");
  const [bodyFatPercentage, setBodyFatPercentage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleFormulaChange = (event) => {
    setFormula(event.target.value);
  };
  const handleBodyFatPercentageChange = (event) => {
    setBodyFatPercentage(event.target.value);
  };
  const calculateBMR = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          weight,
          height,
          age,
          gender,
          formula,
          bodyFatPercentage,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator ini (Kalkulator BMR) menghitung laju metabolisme basal (BMR) yang merupakan energi yang dibutuhkan tubuh dalam keadaan istirahat total untuk mempertahankan fungsi tubuh dasar seperti pernapasan, sirkulasi darah, dan fungsi organ dasar lainnya. Kalkulator laju metabolisme basal dipengaruhi oleh faktor-faktor seperti berat badan, tinggi badan, usia, jenis kelamin, dan persentase lemak tubuh. Laju metabolisme basal dihitung menggunakan berbagai persamaan seperti persamaan Harris-Benedict dan persamaan Mifflin-St Jeor. Laju metabolisme basal penting dalam memperkirakan kebutuhan energi harian individu dan dalam merencanakan program diet dan olahraga.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Laju Metabolisme Basal - Hitung BMR
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Tinggi Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Berat Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      Usia
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >Jenis Kelamin</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="male"
                      value="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label htmlFor="male" className="form-check-label">
                      Laki-laki
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="female"
                      value="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label htmlFor="female" className="form-check-label">
                      Perempuan
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="select" className="form-label ms-2">
                      Pilih Rumus
                    </label>
                  </b>
                  <select
                    id="select"
                    className="form-select"
                    value={formula}
                    onChange={handleFormulaChange}
                  >
                    <option value="harrisBenedictRevised">
                      Harris Benedict Equation (Revisi)
                    </option>
                    <option value="harrisBenedictOriginal">
                      Harris-Benedict Equation (Asli)
                    </option>
                    <option value="mifflinStJeor">Mifflin-St Jeor</option>
                    <option value="schofield">Schofield</option>
                    <option value="oxford">Oxford</option>
                    <option value="katchMcArdle">Katch-McArdle</option>
                    <option value="cunningham">Cunningham</option>
                  </select>
                </div>
                <br />
                {(formula === "katchMcArdle" || formula === "cunningham") && (
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label ms-2">Persentase Lemak</label>
                    </b>
                    <input
                      type="number"
                      id="bodyFatPercentage"
                      value={bodyFatPercentage}
                      onChange={handleBodyFatPercentageChange}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="6"
                      min="2"
                      max="20"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">%</span>
                    </div>
                    <br />
                  </div>
                )}
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateBMR}
                       >
                    Hitung
                    </button>              </div>
              <div className="col-sm-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>Hasil : </h5>
                      Laju Metabolisme Basal Anda: {result.bmr} kalori.
                    </div>
                    <hr />
                    <BMRTable
                      formula={formula}
                      bmr={result.bmr}
                      Sedentary={result.DailyCalorieNeeded.Sedentary}
                      Exercise1_3={result.DailyCalorieNeeded.Exercise1_3}
                      Exercise4_5={result.DailyCalorieNeeded.Exercise4_5}
                      DailyExercise={result.DailyCalorieNeeded.DailyExercise}
                      IntenseExercise={
                        result.DailyCalorieNeeded.IntenseExercise
                      }
                      VeryIntenseExercise={
                        result.DailyCalorieNeeded.VeryIntenseExercise
                      }
                    ></BMRTable>{" "}
                    <br />
                    <div className="alert alert-warning">
                      <ul style={{ fontSize: "13px" }}>
                        <li>
                          Latihan: 15-30 menit dari peningkatan denyut jantung.
                        </li>
                        <li>
                          Latihan Intens: 45-120 menit aktivitas denyut jantung tinggi.
                        </li>
                        <li>
                          Latihan Sangat Intens: Lebih dari 2 jam aktivitas denyut jantung tinggi.
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua kolom dengan benar.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                Laju Metabolisme Basal (BMR) dan Cara Menghitungnya
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Laju Metabolisme Basal (BMR) dan Cara Menghitungnya{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Laju metabolisme basal (BMR) adalah faktor penting yang memainkan peran penting dalam memahami kebutuhan kalori dasar tubuh Anda. Menghitung BMR adalah langkah penting untuk menurunkan berat badan atau mempertahankan berat badan yang sehat. Dalam artikel ini, kita akan melihat konsep BMR dan cara menghitungnya, serta pentingnya mengetahui tingkat BMR Anda.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Apa itu Laju Metabolisme Basal (BMR)?{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Laju metabolisme basal (BMR) mewakili kalori yang dibutuhkan tubuh Anda untuk melakukan fungsi vitalnya saat istirahat total. Ini berkaitan dengan energi yang diperlukan untuk mendukung proses tubuh dasar seperti pernapasan, pemompaan darah, dan pemeliharaan sel. Tingkat BMR dapat bervariasi dari orang ke orang berdasarkan faktor-faktor seperti usia, jenis kelamin, berat badan, dan tinggi badan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Pentingnya Laju Metabolisme Basal untuk Kesehatan{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Mengetahui tingkat BMR Anda adalah langkah awal dalam menentukan kebutuhan kalori harian Anda. BMR dapat digunakan sebagai titik awal untuk menghitung kalori yang Anda butuhkan setiap hari. Perhitungan ini membantu dalam menentukan jumlah kalori yang harus dikonsumsi untuk mempertahankan berat badan Anda saat ini atau untuk mencapai tujuan penurunan berat badan dengan aman.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Bagaimana Laju Metabolisme Basal Mempengaruhi Penurunan Berat Badan?{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Untuk mencapai penurunan berat badan, Anda harus menciptakan defisit kalori, yaitu selisih antara kalori yang Anda konsumsi dan yang dibutuhkan tubuh Anda. Ketika Anda mengetahui BMR Anda, Anda dapat menghitung kalori yang Anda butuhkan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Laju Metabolisme Basal (BMR){" "}
                  </h2>{" "}
                </u>
                Kami menggunakan 7 persamaan berbeda dalam kalkulator ini untuk menghitung laju metabolisme basal seperti yang ditunjukkan di bawah ini:
                <br/>                <div>
                  <b> Harris-Benedict Equation (Asli): </b>
                  <br />
                  Rumus Harris-Benedict asli adalah salah satu rumus yang paling banyak digunakan secara online untuk menghitung kebutuhan energi harian Anda. Namun, itu juga salah satu rumus yang paling tidak akurat.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        Laki-laki: 66,4730 + (13,7516 x berat [kg]) + (5,0033 x tinggi [cm]) - (6,7550 x usia)
                      </li>
                      <li>
                        Perempuan: 655,0955 + (9,5634 x berat [kg]) + (1,8496 x tinggi [cm]) - (4,6756 x usia)
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Harris Benedict Equation (Revisi): </b>
                  <br />
                  Pada tahun 1984, rumus Harris-Benedict direvisi oleh Roza dan Shizgal. Set penelitian yang lebih besar digunakan dalam revisi ini.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        Laki-laki: 88,362 + (13,397 x berat [kg]) + (4,799 x tinggi [cm]) - (5,677 x usia)
                      </li>
                      <li>
                        Perempuan: 447,593 + (9,247 x berat [kg]) + (3,098 x tinggi [cm]) - (4,33 x usia)
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Mifflin-St Jeor:</b>
                  <br />
                  Pada tahun 1990, persamaan Mifflin-St Jeor diperkenalkan. Pada tahun 2005, American Dietetic Association (ADA) membandingkan persamaan BMR Harris-Benedict, Mifflin-St Jeor, Owen, dan WHO/FAO/UNU dan menemukan bahwa persamaan Mifflin-St Jeor adalah yang paling akurat, memprediksi BMR dalam 10% dari nilai yang diukur.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        Laki-laki: (9,99 x berat [kg]) + (6,25 x tinggi [cm]) - (4,92 x usia) + 5
                      </li>
                      <li>
                        Perempuan: (9,99 x berat [kg]) + (6,25 x tinggi [cm]) - (4,92 x usia) - 161
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Schofield </b>
                  <br />
                  Persamaan Schofield diterbitkan pada tahun 1985 dan digunakan oleh FAO/WHO/UNU dan lainnya. Namun, ada jumlah peserta yang tidak proporsional dalam kumpulan data yang merupakan pria Italia yang rata-rata memiliki nilai BMR lebih tinggi. Ini secara tidak adil mempengaruhi hasil untuk komunitas lain.
                  <u>Dihitung sebagai berikut:</u> <br/>                  <b>Laki-laki:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">Usia</th>
                        <th className="formula-header">Persamaan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>61,0 x berat [kg] - 33,7</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>23,3 x berat [kg] + 514</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>18,4 x berat [kg] + 581</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>16,0 x berat [kg] + 545</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>14,2 x berat [kg] + 593</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>13,5 x berat [kg] + 514</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <b>Perempuan:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">Usia</th>
                        <th className="formula-header">Persamaan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>58,317 x berat [kg] - 31,1</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>20,315 x berat [kg] + 485,9</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>13,384 x berat [kg] + 692,6</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>14,818 x berat [kg] + 486,6</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>8,126 x berat [kg] + 845,6</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>9,082 x berat [kg] + 658,5</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
                <br />
                <div>
                  <b> Oxford : </b>
                  <br />
                  Seperti yang terlihat dari persamaan yang disebutkan sebelumnya, ketidakandalan persamaan Schofield telah terbukti untuk banyak orang. Berdasarkan ini, serangkaian persamaan baru dikembangkan pada tahun 2005, yang ditandai dengan didasarkan pada database yang berisi 10.552 nilai BMR, dan mencakup kelompok peserta yang lebih beragam.
                  <u>Dihitung sebagai berikut:</u> <br/>                  <b>Laki-laki:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">Usia</th>
                        <th className="formula-header">Persamaan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>61,0 x berat [kg] - 33,7</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>23,3 x berat [kg] + 514</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>18,4 x berat [kg] + 581</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>16,0 x berat [kg] + 545</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>14,2 x berat [kg] + 593</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>13,5 x berat [kg] + 514</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <b>Perempuan:</b> <br />
                  <table >
                    <thead>
                      <tr>
                        <th className="formula-header">Usia</th>
                        <th className="formula-header">Persamaan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0-3</td>
                        <td>58,9 x berat [kg] - 23,1</td>
                      </tr>
                      <tr>
                        <td>3-10</td>
                        <td>20,1 x berat [kg] + 507</td>
                      </tr>
                      <tr>
                        <td>10-18</td>
                        <td>11,1 x berat [kg] + 761</td>
                      </tr>
                      <tr>
                        <td>18-30</td>
                        <td>13,1 x berat [kg] + 558</td>
                      </tr>
                      <tr>
                        <td>30-60</td>
                        <td>9,74 x berat [kg] + 694</td>
                      </tr>
                      <tr>
                        <td>60+</td>
                        <td>10,1 x berat [kg] + 569</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <div>
                  <b> Katch-McArdle:</b>
                  <br />
                  Baik persamaan Katch-McArdle maupun Cunningham menggunakan massa tubuh tanpa lemak untuk memperkirakan BMR. Jika Anda mengetahui persentase lemak tubuh Anda, massa tubuh tanpa lemak dapat dihitung menggunakan rumus berikut: (1 - persentase lemak tubuh / 100) × berat badan. Harap dicatat bahwa dalam kalkulator BMR di atas, massa tubuh tanpa lemak dihitung secara otomatis menggunakan rumus Boer jika persentase lemak tubuh tidak diberikan.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>370 + (21,6 x massa tubuh tanpa lemak [kg])</li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Cunningham</b>
                  <br />
                  Persamaan Cunningham lebih akurat untuk orang yang sangat atletis.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>500 + (22 x massa tubuh tanpa lemak [kg])</li>
                    </ul>
                  </div>
                </div>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Beberapa manfaat utama menghitung BMR adalah{" "}
                  </h2>{" "}
                </u>
                <ol>
                  <li>
                    Mengetahui kebutuhan nutrisi dasar Anda: Menghitung BMR membantu Anda memperkirakan kalori dasar yang dibutuhkan tubuh Anda untuk mempertahankan fungsi dasarnya. Ini berarti Anda akan dapat menentukan jumlah energi yang Anda butuhkan setiap hari berdasarkan angka dasar ini.
                  </li>
                  <li>
                    Perencanaan diet sesuai tujuan: Jika Anda bertujuan untuk menambah atau menurunkan berat badan, Anda dapat menggunakan BMR sebagai dasar untuk menghitung jumlah kalori yang diperlukan untuk mencapai tujuan ini. Dengan meningkatkan kalori Anda dapat menambah berat badan, dan dengan menguranginya Anda dapat menurunkan berat badan.
                  </li>
                  <li>
                    Perencanaan olahraga dan aktivitas fisik: BMR dapat digunakan untuk menentukan jumlah kalori yang dapat Anda bakar selama olahraga dan aktivitas fisik. Ini dapat membantu Anda dalam menjadwalkan olahraga dan memilih aktivitas yang tepat untuk mencapai tujuan kesehatan dan kebugaran Anda.
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa itu laju metabolisme basal (BMR) yang baik untuk usia saya?
                </h3>
              </div>
              <div className="info-section-body">
                Laju metabolisme basal (BMR) yang baik untuk usia Anda tergantung pada lebih dari sekadar usia itu sendiri - jenis kelamin, tinggi badan, dan berat badan juga berperan. Dan lebih banyak penelitian menunjukkan bahwa setiap sepuluh tahun, BMR pada orang dewasa menurun 1% hingga 2% karena hilangnya otot rangka. Aman untuk mengatakan bahwa jika Anda mempertahankan berat badan yang sehat dengan mengikuti rekomendasi kesehatan gaya hidup, Anda dapat mempertahankan BMR yang sehat untuk usia Anda.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa kalkulator BMR paling akurat?</h3>
              </div>
              <div className="info-section-body">
                Ada banyak rumus yang umum digunakan untuk menghitung BMR, termasuk (namun tidak terbatas pada) persamaan Harris-Benedict yang direvisi, persamaan Katch-McArdle, dan persamaan Mifflin-St Jeor. Saat ini, para ahli menganggap persamaan Mifflin-St Jeor sebagai yang paling akurat, itulah sebabnya kami menggunakannya dalam alat kalkulator kami di atas.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Haruskah saya makan sesuai BMR saya untuk menurunkan berat badan?
                </h3>
              </div>
              <div className="info-section-body">
                Karena BMR mewakili jumlah energi yang dibutuhkan tubuh Anda untuk mempertahankan fungsi vitalnya setiap hari, tidak disarankan untuk secara teratur mengonsumsi lebih sedikit dari BMR Anda. Seperti diet restriktif rendah kalori lainnya, tubuh Anda akan secara naluriah merespons dengan menyimpan lebih banyak energi daripada menggunakannya karena mengantisipasi aliran energi baru yang terbatas. Sebagai gantinya, Anda dapat mempertimbangkan tips yang disetujui para ahli ini untuk menurunkan berat badan dengan cara yang aman dan berkelanjutan.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Untuk apa laju metabolisme basal digunakan?
                </h3>
              </div>
              <div className="info-section-body">
                Laju metabolisme basal digunakan untuk membantu seseorang dan penyedia layanan kesehatan mereka memahami jumlah energi (atau kalori) yang dibutuhkan tubuh mereka untuk mempertahankan fungsi vitalnya setiap hari. Dengan informasi ini, individu dapat lebih memahami kebutuhan energi dasar tubuh mereka, dan para ahli dapat mulai merancang berbagai intervensi kesehatan, seperti rencana diet atau olahraga yang disesuaikan dengan tujuan kesehatan khusus orang tersebut dengan cara yang aman, efektif, dan berkelanjutan.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah lebih baik memiliki laju metabolisme basal tinggi atau rendah?
                </h3>
              </div>
              <div className="info-section-body">
                Tidak lebih baik atau lebih buruk memiliki BMR tinggi atau rendah - pengukuran ini hanya proporsional dengan massa tubuh tanpa lemak seseorang, dan tidak selalu merupakan indikasi kesehatan yang optimal. Misalnya, seseorang yang mengalami obesitas cenderung memiliki BMR lebih tinggi daripada seseorang yang tidak obesitas karena mereka membutuhkan lebih banyak energi untuk melakukan aktivitas penahan beban seperti berjalan dan berdiri. Sementara itu, seseorang yang kurus dengan massa otot besar cenderung memiliki BMR lebih tinggi daripada seseorang yang kurus tanpa banyak massa otot karena alasan yang sama. Tingkat BMR yang optimal tergantung pada individu, status kesehatan, dan tujuan kesehatan khusus mereka.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Haruskah BMR saya menurun seiring penurunan berat badan?
                </h3>
              </div>
              <div className="info-section-body">
                Singkatnya, itu tergantung pada strategi yang digunakan untuk menurunkan berat badan. Banyak orang yang menurunkan berat badan karena pembatasan kalori saja pada akhirnya mengurangi pengeluaran energi tubuh mereka (dan BMR) karena bagaimana metabolisme beradaptasi dengan pembatasan ini. Namun, seseorang yang kehilangan massa lemak tubuh sambil meningkatkan massa otot mungkin kehilangan berat badan pada tingkat yang lebih lambat tetapi kemungkinan akan meningkatkan BMR pada tingkat perubahan komposisi tubuh mereka.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BMRCalculator;